import { NgModule } from '@angular/core';
import { LoaderComponent } from './loader.component';

@NgModule({
  imports: [LoaderComponent],
  exports: [LoaderComponent]
})
export class LoaderModule {}
